import z from "zod";
import { ENTITY_NAMES } from "@miplatform/constants";
import { DOC_CATEGORY } from "../../CreateBid/constants";

export const schema = z.object({
  name: z.string().min(1, `${ENTITY_NAMES.BID_REQUEST} name is required`),
  builderId: z.string().min(1, "Customer is required"),
  communityId: z.string().nullable().optional(),
  dueDate: z.string().min(1, "Due date is required"),
  requestDate: z.string().min(1, "Request date is required"),
  requesterId: z.string().min(1, "Requester is required"),
  assigneeId: z.string().nullable().optional(),
  seriesGroupId: z.string().nullable().optional(),
  seriesId: z.string().nullable().optional(),
  bids: z.array(
    z
      .object({
        bidId: z.string(),
        name: z.string().min(1, "Bid name is required"),
        documents: z.array(
          z.object({
            category: z.string().optional(),
          })
        ),
      })
      .refine(
        (data) => data.documents.some((d) => d.category === DOC_CATEGORY.PLAN),
        { message: "Plan file is required", path: ["documents"] }
      )
      .refine(
        (data) => data.documents.some((d) => d.category === DOC_CATEGORY.SPEC),
        { message: "Spec file is required", path: ["documents"] }
      )
  ),
});
